// assets
import {
  LoginOutlined,
  ProfileOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { FormattedMessage, useIntl } from "react-intl";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DescriptionIcon from "@mui/icons-material/Description";
import GroupIcon from "@mui/icons-material/Group";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
// icons

const useUsefulInfoItems = () => {
  const icons = {
    LoginOutlined,
    ProfileOutlined,
    FileTextOutlined,
    BusinessCenterOutlinedIcon,
    SettingsOutlinedIcon,
    CheckCircleOutlineIcon,
    DescriptionIcon,
    GroupIcon,
    ToggleOnIcon,
    ToggleOffIcon,
  };

  // ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

  const usefulInfo = {
    id: "useful-information",
    title: (
      <FormattedMessage id="Recommendations">
        {(text) => (
          <span style={{ fontSize: "14px", fontWeight: "normal" }}>{text}</span>
        )}
      </FormattedMessage>
    ),
    icon: icons.DescriptionIcon,
    type: "group",
    // url: "/recommendations",

    children: [
      {
        id: "recommendations",
        title: <FormattedMessage id="Recommendations List" />,
        type: "item",
        url: "/recommendations",
        icon: icons.ToggleOnIcon,
        breadcrumbs: false,
      },
      {
        id: "recommendations-sent-mails",
        title: <FormattedMessage id="Recommendations Sent Emails" />,
        type: "item",
        url: "/recommendations-sent-mails",
        icon: icons.ToggleOffIcon,
        breadcrumbs: false,
      },
    ],
  };
  return usefulInfo;
};

export default useUsefulInfoItems;
